//#region [IMPORT]

// === THIRD-PARTY ==
import { useNavigate } from "react-router-dom";

// === API ===
import { prokeyApi } from "api/prokey";

//#endregion

//-----------------------------------------------------------------
export const useLogout = () => {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const navigate = useNavigate();

  //#endregion

  //#region [METHOD]

  async function logout() {
    try {
      const response = await prokeyApi.logout();
      navigate('login');
    } catch (error) {
      console.warn( error );
    }
  }

  //#endregion

  return logout;
};
